<template>
    <div class="select-layout main">
        <round-btn
            shadow-color="rgba(171, 203, 216, 0.5)"
            :background-color="backgroundColor"
            color="#ffffff"
            font-size="1.5em"
            max-height="95px"
            min-height="80px"
            @click="$emit('select', { level: '1' })"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Select/icon1.png"
                    alt=""
                    class="icon"
                />
                <div class="text">{{ copywriting.level1 }}</div>
                <img
                    src="@/assets/Stage/Select/Triangle.png"
                    alt=""
                    class="arrow"
                />
            </div>
        </round-btn>
        <round-btn
            shadow-color="rgba(171, 203, 216, 0.5)"
            :background-color="backgroundColor"
            color="#ffffff"
            font-size="1.5em"
            max-height="95px"
            min-height="80px"
            @click="$emit('select', { level: '2' })"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Select/icon2.png"
                    alt=""
                    class="icon"
                />
                <div class="text">{{ copywriting.level2 }}</div>
                <img
                    src="@/assets/Stage/Select/Triangle.png"
                    alt=""
                    class="arrow"
                />
            </div>
        </round-btn>
        <round-btn
            shadow-color="rgba(171, 203, 216, 0.5)"
            :background-color="backgroundColor"
            color="#ffffff"
            font-size="1.5em"
            max-height="95px"
            min-height="80px"
            @click="$emit('select', { level: '3' })"
        >
            <div class="button-content">
                <img
                    src="@/assets/Stage/Select/icon3.png"
                    alt=""
                    class="icon"
                />
                <div class="text">{{ copywriting.level3 }}</div>
                <img
                    src="@/assets/Stage/Select/Triangle.png"
                    alt=""
                    class="arrow"
                />
            </div>
        </round-btn>
    </div>
</template>

<script>
export default {
    props: {
        backgroundColor: String,
        copywriting: Object,
    },
};
</script>

<style lang="scss" scoped>
.select-layout {
    margin-top: min(30px, 4vh);
    > * {
        margin-bottom: 3vh;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.button-content {
    display: flex;
    align-items: center;
    width: 100%;
    .icon {
        margin: 0 10px;
        width: auto;
        height: 90%;
        transform: translateY(-5%);
    }
    .arrow {
        margin: 0 15px;
        width: 30px;
        height: 30px;
    }
    .text {
        flex: 1;
        text-align: center;
    }
}
</style>
